import React, { useState, useEffect } from 'react';
import { LoginPage } from './components/layout/LoginPage';
import { SessionExpiredModal } from './components/layout/SessionExpiredModal';
import { AppLayout } from './components/layout/AppLayout';

export default function App() {
  const [token, setToken] = useState<string | null>(null);
  const [checking, setChecking] = useState(true);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    // Restaurar sesión si ya hay token guardado
    const saved = localStorage.getItem('access_token');
    if (saved) setToken(saved);
    setChecking(false);

    // Listen for session expiry events from api.ts
    const handleExpired = () => setSessionExpired(true);
    window.addEventListener('session:expired', handleExpired);
    return () => window.removeEventListener('session:expired', handleExpired);
  }, []);

  const handleLogin = (t: string) => setToken(t);

  const handleLogout = () => {
    localStorage.clear();
    setToken(null);
  };

  if (checking) return null;

  if (!token) return <LoginPage onLogin={handleLogin} />;

  return (
    <>
      <AppLayout onLogout={handleLogout} />
      {sessionExpired && (
        <SessionExpiredModal
          onSuccess={(newToken) => {
            setToken(newToken);
            setSessionExpired(false);
          }}
        />
      )}
    </>
  );
}